import {BUSCAR_PRECOS_ROTA} from '../../actions/types'

const initialState = []

export default function reducerPrecosRota (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_PRECOS_ROTA: {
      return action.payload.data;
    }
    default: {
      return state
    }
  }
}
